<div class="detail-order-container padding-content-dialog">
  <app-detail-orders-list
    [stringOrderId]="stringOrderId"
    [whoRequest]="place"
    [docNum]="docNum"
    [isAuthorizeOrder]="isAuthorizeOrder"
    [isPaymentProcessed]="isPaymentProcessed"
    [statusOrder]="statusOrder"
    (closeDialog)="closeDialog($event)"
    (closeDialogEmpty)="closeDialogEmpty()"
    [showFavoriteButton]="data.showFavoriteButton"
  ></app-detail-orders-list>
</div>
